import React, { createContext, useContext, useState, useEffect } from "react";
import { AuthService } from "../services/auth.service";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for existing token/user on load
    const token = localStorage.getItem("accessToken");
    const storedUser = localStorage.getItem("user");
    
    if (token && storedUser) {
      try {
          setUser(JSON.parse(storedUser));
          setIsAuthenticated(true);
      } catch (e) {
          console.error("Failed to parse stored user", e);
          localStorage.removeItem("accessToken");
          localStorage.removeItem("user");
      }
    }
    setLoading(false);
  }, []);

  const login = async (role, email, password) => {
    setLoading(true);
    try {
      let data;
      if (role === 'admin') {
        data = await AuthService.loginAdmin(email, password);
      } else {
        data = await AuthService.loginEmployee(email, password);
      }
      
      const { token, user: userData } = data;
      
      localStorage.setItem("accessToken", token);
      localStorage.setItem("user", JSON.stringify(userData));
      
      setUser(userData);
      setIsAuthenticated(true);
      return userData; // Return user to help with redirection
    } catch (error) {
      console.error("Login failed", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    AuthService.logout();
    localStorage.removeItem("user");
    setUser(null);
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
